import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {Checkbox, FormControlLabel, RadioGroup} from "@material-ui/core";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import {timeUnits, translateTimeUnit} from "./FTFCSetup";
import {
    parseFloatInputOrEmpty,
    parseIntegerInputOrEmpty,
} from "../../../../../utils/forms/parseNumberInput";

const candleColors = ["RED", "GREEN"];
const candleTypes = ["LAST"]
export default function BreakCandleTypeSetup({top, dispatchTop, setupFields, dispatchSetUpDetails}) {
    const [candleDurationTxt, setCandleDuration] = useState(setupFields.candleDuration);
    const [breakByTxt, setBreakByTxt] = useState(setupFields.breakBy);

    useEffect(() => {
        setCandleDuration(setupFields.candleDuration);
        setBreakByTxt(setupFields.breakBy);
    }, [setupFields]);

    return <Grid item container>
        <RadioGroup
            row
            aria-label="candleType"
            name="candleType"
            value={setupFields.candleType}
            onChange={(ev) => {
                //console.log(ev.target);
                dispatchSetUpDetails({
                    candleType: ev.target.value,
                })
            }}
        >
            {candleTypes.map((ct) => {
                //console.log(tu);
                return (
                    <Grid item xs={2} key={ct}>
                        <FormControlLabel
                            value={ct}
                            checked={ct === setupFields.candleType}
                            labelPlacement="bottom"
                            control={<StyledRadio/>}
                            label={
                                <Typography style={{fontSize: 8}}>{ct}</Typography>
                            }
                        />
                    </Grid>
                );
            })}
        </RadioGroup>
        <RadioGroup
            row
            aria-label="candleColor"
            name="candleColor"
            value={setupFields.candleColor}
            onChange={(ev) => {
                //console.log(ev.target);
                dispatchSetUpDetails({
                    candleColor: ev.target.value,
                })
            }}
        >
            {candleColors.map((cc) => {
                //console.log(tu);
                return (
                    <Grid item xs={3} key={cc}>
                        <FormControlLabel
                            value={cc}
                            checked={cc === setupFields.candleColor}
                            labelPlacement="bottom"
                            control={<StyledRadio/>}
                            label={
                                <Typography style={{fontSize: 8}}>{cc}</Typography>
                            }
                        />
                    </Grid>
                );
            })}
        </RadioGroup>
        <Grid item xs={2}>
            <TextField
                variant="outlined"
                id="outlined-basic"
                size={"small"}
                label={
                    <Typography style={{fontSize: 10}}>
                        Candle Duration
                    </Typography>
                }
                value={candleDurationTxt}
                onChange={(ev) =>
                    dispatchSetUpDetails({
                        candleDuration: parseIntegerInputOrEmpty(ev.target.value),
                    })
                }
            />
        </Grid>
        <Grid item xs={2}>
            <TextField
                variant="outlined"
                id="outlined-basic"
                size={"small"}
                label={
                    <Typography style={{fontSize: 12}}>break by</Typography>
                }
                value={breakByTxt}
                onChange={(ev) => setBreakByTxt(ev.target.value)}
                onBlur={(ev) =>
                    dispatchSetUpDetails({
                        breakBy: parseFloatInputOrEmpty(ev.target.value),
                    })
                }
            />
        </Grid>
        <Grid item xs={3}>
            <FormControlLabel
                value="top"
                control={
                    <Checkbox
                        color="primary"
                        checked={setupFields.filterForToday}
                        onChange={(ev) =>
                            dispatchSetUpDetails({
                                filterForToday: ev.target.checked,
                            })
                        }
                    />
                }
                label={
                    <Typography style={{fontSize: 10}}>filter for today</Typography>
                }
                labelPlacement="top"
                size="small"
            />
        </Grid>
    </Grid>
}
